module.exports = __webpack_public_path__ + "img/moneymex_scroll05.f5500fa7.webp";